import { Link } from "react-router-dom";
import { categories, siteMeta } from "@/mocks/comics";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg"></i>
              </span>
              <span className="font-heading text-2xl text-foreground-950">
                韩漫<span className="text-primary-600">YY</span>榜
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              {siteMeta.slogan}。人气榜单与完结漫画分类实时更新，帮你快速定位想看的韩漫。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li><Link to="/#ranking" className="hover:text-primary-600">人气榜单</Link></li>
              <li><Link to="/#new" className="hover:text-primary-600">新番抢先看</Link></li>
              <li><Link to="/categories" className="hover:text-primary-600">题材分类</Link></li>
              <li><Link to="/about" className="hover:text-primary-600">关于我们</Link></li>
              <li><Link to="/faq" className="hover:text-primary-600">常见问题</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">题材分类</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              {categories.slice(0, 4).map((c) => (
                <li key={c.id}>
                  <Link to={`/category/${c.id}`} className="hover:text-primary-600">{c.name} · {c.en}</Link>
                </li>
              ))}
              <li>
                <Link to="/categories" className="hover:text-primary-600">查看全部分类</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href={`mailto:${siteMeta.email}`} className="hover:text-primary-600">{siteMeta.email}</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line"></i>
                <span>韩漫YY榜</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span>榜单每日 00:00 更新</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © {year} {siteMeta.name} · 本站内容为虚构推荐展示
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <Link to="/about" className="hover:text-primary-600">网站介绍</Link>
            <Link to="/faq" className="hover:text-primary-600">帮助中心</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}